import http from '@/biz/http.mjs'
import useSwrNoCache from '@/script/useSwrNoCache.mjs'

export const readStatements = () => http.get(
    '/basBODAStatement/listBasBODAStatement'
)

export const useStatements = () => {
    const {data} = useSwrNoCache(readStatements)
    return data ?? []
}
